import {
  QueryClient,
  QueryClientProvider,
  QueryFunction,
} from '@tanstack/react-query';

import { createContext, ReactElement, useCallback, useRef } from 'react';
import { AppQueryFunctionsProvider } from '../queryFunctionsProvider';

import { constants, types } from './definitions';
import { AddQueryFnType, QueryFns } from './definitions/types';
import { QueryFnContextProps } from '../queryFunctionsProvider/definitions/types';

const queryFns: QueryFns = {
  store: {},
};

export const QueryFnContext = createContext<QueryFns>(queryFns);
export const AddQueryFnContext = createContext<AddQueryFnType>(() => undefined);

/**
 * Query function context provider
 * @param children - the children to render
 * @constructor - the query function context provider
 */
export function QueryFnContextProvider({ children }: QueryFnContextProps) {
  const fns = useRef<QueryFns>(queryFns);

  const addFn = useCallback(
    (key: string, queryFns: Record<string, QueryFunction>) => {
      if (!fns.current.store[key]) {
        fns.current.store = { ...fns.current.store, [key]: queryFns };
      }
    },
    [],
  );

  return (
    <QueryFnContext.Provider value={fns.current}>
      <AddQueryFnContext.Provider value={addFn}>
        {children}
      </AddQueryFnContext.Provider>
    </QueryFnContext.Provider>
  );
}

export const queryClient = new QueryClient({
  defaultOptions: constants.defaultOptions,
});

export const AppQueriesProvider = ({
  children,
}: types.AppQueriesProviderProps): ReactElement<types.AppQueriesProviderProps> => {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryFnContextProvider>
        <AppQueryFunctionsProvider>{children}</AppQueryFunctionsProvider>
      </QueryFnContextProvider>
    </QueryClientProvider>
  );
};
